import { safeLocalStorage } from '@toss/storage';

import { safeRandomUUID } from './safeRandomUUID';

export const GUEST_SESSION_ID_STORAGE_KEY = '@p@@ze__guest_session_id';

const UUID_RE =
  /^[0-9a-f]{8}-[0-9a-f]{4}-[1-5][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i;

const isUuid = (value: unknown): value is string =>
  typeof value === 'string' && UUID_RE.test(value);

/**
 * 게스트 중복 접속을 판별하기 위한 전용 UUID를 반환합니다.
 * 로그·Feature Flag·Socket에서 사용하는 전역 device ID가 바뀌지 않도록 별도
 * localStorage 키에 저장하며, 같은 브라우저의 여러 탭에서 동일한 값을 공유합니다.
 */
export const getOrCreateGuestSessionId = (): string | undefined => {
  if (typeof window === 'undefined') {
    return undefined;
  }

  const storedId = safeLocalStorage.get(GUEST_SESSION_ID_STORAGE_KEY);
  if (isUuid(storedId)) {
    return storedId;
  }

  const guestSessionId = safeRandomUUID();
  safeLocalStorage.set(GUEST_SESSION_ID_STORAGE_KEY, guestSessionId);
  return guestSessionId;
};
